import makeRequest from 'api/makeRequest';
import environment from 'environment';

/**
 * Fetches data for active dynamic integrations
 * We use this data to determine which COI search options are active
 *
 * @param {object} params
 * @param {string} params.simplrAccountId
 * @param {string=} params.brand
 *
 * @returns {Promise}
 */
export const fetchDynamicIntegrations = async (params) => {
  return await makeRequest(`${environment.eCommerce.DYNAMIC_INTEGRATIONS_BASE_URL}/active-integrations`, {
    params,
  });
};
